import { useEffect, useRef, useState } from "react";
import useEffectRange from "src/hooks/useEffectUtils/useEffectRange";
import useIsOnline from "../hooks/useIsOnline";
import useAnimations from "./useAnimations";
export default function useNetworkAnimations() {
    const [isVisible, setIsVisible] = useState(false);
    const currentAnimation = useRef(null);
    const currentAnimationTimeout = useRef(null);
    const cleanup = () => {
        currentAnimation.current?.stop();
        currentAnimationTimeout.current && clearTimeout(currentAnimationTimeout.current);
    };
    const animations = useAnimations();
    useEffect(() => {
        return () => {
            cleanup();
        };
    }, []);
    const animate = (isOnlineState) => {
        setIsVisible(true);
        cleanup();
        currentAnimation.current = animations.getAnimateIn();
        currentAnimation.current.start(({ finished: finishedIn }) => {
            if (!finishedIn)
                return;
            currentAnimation.current = null;
            currentAnimationTimeout.current = setTimeout(() => {
                if (currentAnimation.current)
                    return;
                currentAnimation.current = animations.getAnimateOut(isOnlineState);
                currentAnimation.current.start(({ finished: finishedOut }) => {
                    if (!finishedOut)
                        return;
                    currentAnimation.current = null;
                    if (isOnlineState) {
                        setIsVisible(false);
                    }
                });
            }, isOnlineState ? 2000 : 3000);
        });
    };
    const isOnline = useIsOnline();
    useEffectRange([1], () => {
        animate(isOnline);
    }, [isOnline]);
    return {
        containerAnimatedStyle: animations.containerAnimatedStyle,
        textAnimatedStyle: animations.textAnimatedStyle,
        isVisible,
    };
}
